export const planCards = [
  {
    id: "starter",
    min: 250,
    max: 350,
    title: "Starter",
    minutes: "300",
    calls: "120",
    tag: "FREE VoIP Number",
    ulTitle: "Plan includes:",
    features: [
      "300 minutes / month",
      "FREE VoIP Number",
      "Agent Characterization",
      "Email Notifications",
    ],
    icon: "/Svg/Starter-Icon.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 119, yearly: 99 },
      GB: { currency: "GBP", symbol: "£", monthly: 89, yearly: 74 },
      CA: { currency: "CAD", symbol: "$", monthly: 159, yearly: 133.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 179, yearly: 149.92 },
      // IN: { currency: "USD", symbol: "$", monthly: 119, yearly: 99 },
    },
    colors: {
      title: "#E83BAC",
      minutesBorder: "#E83BAC",
      featureBg: "#FFEDF9",
      featureColor: "#E83BAC"
    },
    badgeImage: "/Svg/better-option-price.svg"
  },
  {
    id: "scaler",
    title: "Scaler",
    min: 350,
    max: 800,
    minutes: "750",
    calls: "300",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "750 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    popular: true,
    icon: "/Svg/Plan02.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 299, yearly: 249 },
      GB: { currency: "GBP", symbol: "£", monthly: 219, yearly: 183.25 },
      CA: { currency: "CAD", symbol: "$", monthly: 399, yearly: 333.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 459, yearly: 383.25 },
      // IN: { currency: "USD", symbol: "$", monthly: 299, yearly: 249 },
    },
    colors: {
      title: "#FE5E00",
      minutesBorder: "#FE5E00",
      featureBg: "#FFECE0",
      featureColor: "#FE5E00"
    },
    badgeImage: "/Svg/better-option-price2.svg"
  },
  {
    id: "growth",
    min: 800,
    max: 4000,
    title: "Growth",
    minutes: "1500",
    calls: "600",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "1500 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    icon: "/Svg/Plan03.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 599, yearly: 499 },
      GB: { currency: "GBP", symbol: "£", monthly: 439, yearly: 370.75 },
      CA: { currency: "CAD", symbol: "$", monthly: 819, yearly: 684.91 },
      AU: { currency: "AUD", symbol: "$", monthly: 919, yearly: 774.91 },
      // IN: { currency: "USD", symbol: "$", monthly: 599, yearly: 499 },
    },
    colors: {
      title: "#00A4FF",
      minutesBorder: "#00A4FF",
      featureBg: "#E9F7FF",
      featureColor: "#00A4FF"
    },
    badgeImage: "/Svg/better-option-price3.svg"

  },
  // {
  //   title: "Corporate",
  //   minutes: "3000",
  //   calls: "1200",
  //   tag: "FREE VoIP Number",
  //   ulTitle: "Everything in Starter",
  //   features: [
  //     "3000 minutes / month",
  //     "FREE VoIP Number",
  //     "Multi-Lingual with In-Call Language Switching",
  //     "Agent Characterization",
  //   ],
  //   icon: "/Svg/Plan04.svg",
  //   pricing: {
  //     US: { currency: "USD", symbol: "$", monthly: 999, yearly: 799 },
  //     GB: { currency: "GBP", symbol: "£", monthly: 739, yearly: 594.08 },
  //     CA: { currency: "CAD", symbol: "$", monthly: 1369, yearly: 1083.25 },
  //     AU: { currency: "AUD", symbol: "$", monthly: 1549, yearly: 1249.91 },
  //     IN: { currency: "USD", symbol: "$", monthly: 999, yearly: 799 },
  //   },
  // },
];
